module.exports = __webpack_public_path__ + "images/emoji/punch.5546128762e3d535da1f.png";